import { Game } from '@core/Game';

// Entry point for Laika MMO client
async function main(): Promise<void> {
  console.log('🎮 Laika MMO Client initializing...');

  // Get canvas element
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
  if (!canvas) {
    throw new Error('Game canvas not found!');
  }

  // Update loading progress
  const loadingBar = document.getElementById('loading-bar');
  const loadingText = document.getElementById('loading-text');

  const updateLoading = (progress: number, text: string) => {
    if (loadingBar) loadingBar.style.width = `${progress}%`;
    if (loadingText) loadingText.textContent = text;
  };

  try {
    updateLoading(20, 'Creating game engine...');

    // Initialize game
    const game = new Game({
      canvas,
      showFPS: true,
    });

    updateLoading(50, 'Loading assets...');

    // Simulate asset loading (will be real later)
    await new Promise((resolve) => setTimeout(resolve, 500));

    updateLoading(80, 'Initializing systems...');

    await new Promise((resolve) => setTimeout(resolve, 300));

    updateLoading(100, 'Starting game...');

    await new Promise((resolve) => setTimeout(resolve, 200));

    // Start the game loop
    game.start();

    // Expose game instance for debugging
    (window as unknown as { game: Game }).game = game;

    // Handle pause on visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        game.pause();
      } else {
        game.resume();
      }
    });

    // Handle keyboard shortcuts
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        game.togglePause();
      }
    });

    console.log('✅ Laika MMO Client ready!');
    console.log('💡 Tip: Press ESC to pause/resume');
    console.log('💡 Tip: Access game via window.game in console');

  } catch (error) {
    console.error('❌ Failed to initialize game:', error);
    if (loadingText) {
      loadingText.textContent = 'Failed to load game. Please refresh.';
      loadingText.style.color = '#e94560';
    }
  }
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
